import type { SitePopulationChartRange } from "@situate/contracts";

interface LiveViewChartOption {
  value: SitePopulationChartRange;
  label: string;
}

export const LIVE_VIEW_CHART_OPTIONS: readonly LiveViewChartOption[] = [
  { value: "15m", label: "15 minutes" },
  { value: "30m", label: "30 minutes" },
  { value: "1h", label: "1 hour" },
  { value: "3h", label: "3 hours" },
  { value: "12h", label: "12 hours" },
  { value: "24h", label: "24 hours" },
];

export type LiveViewTimeRange = SitePopulationChartRange;

export const DEFAULT_LIVE_VIEW_TIME_RANGE: LiveViewTimeRange = "30m";
